export default {
  namespaced: true,
  state: {
    message: null,
    color: null,
    timeout: null,
    show: false
  },
  mutations: {
    /**
     * Notify a message to the user with a snackbar.
     *
     * @param {String} payload.message - Message to show to the user.
     * @param {String} payload.type - Type of the message. Supports: 'success' and 'error'. If no one is provided
     * it shows the default color.
     */
    notify(state, { message, type, timeout }) {
      if (type && ['error', 'success'].indexOf(type) === -1) {
        throw new Error(`Please provide a supported type ('error' or 'success'). Actual: ${type}`)
      }
      state.message = message
      state.color = type
      state.timeout = timeout || 5000
      state.show = true
    },
    error(state, payload) {
      this.commit('notifications/notify', { type: 'error', ...payload })
    },
    success(state, payload) {
      this.commit('notifications/notify', { type: 'success', ...payload })
    },
    /**
     * Set the show property of the state that indicates if a snackbar is showing or not.
     *
     * @param {Object} state The state of the module.
     * @param {Boolean} show The value to set.
     */
    setShow(state, show) {
      state.show = show
    }
  }
}
